import { all } from 'redux-saga/effects';
import notificationSaga from './notification/notificationSaga';
import sessionSaga from './session/sessionSaga';
import handleApiError from './handler/errorSaga';
import routeSaga from './route/routeSaga';
import accountSaga from './account/accountSaga';
import dataSaga from './data/dataSaga';
import messageSaga from './message/messageSaga';
import dashboardSaga from './dashboard/dashboardSaga';
import disclosureSaga from './disclosure/disclosureSaga';
import companySaga from './company/companySaga';
import uploadSaga from "./upload/uploadSaga";

// single entry point to start all Sagas at once
export default function * rootSaga () {
  yield all([
    sessionSaga(),
    notificationSaga(),
    handleApiError(),
    routeSaga(),
    accountSaga(),
    dataSaga(),
    messageSaga(),
    dashboardSaga(),
    disclosureSaga(),
    companySaga(),
    uploadSaga()
  ]);
}
